import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Fetch } from '@app/models/fetch';
import { Notification } from '@app/models/notifications/notifications.model';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
export class NotificationService {
    constructor(fetch) {
        this.fetch = fetch;
        this.baseUrl = '/notifications';
        // observable for unread notifications
        this._unreadNotifications = new BehaviorSubject(null);
        this.unreadNotifications = this._unreadNotifications.asObservable(); // eslint-disable-line
    }
    get(id) {
        return this.fetch.getOne(this.baseUrl, id).model(Notification);
    }
    getPage(page, options) {
        return this.fetch.getPage(this.baseUrl, page, options).models(Notification);
    }
    getAll(options) {
        return this.fetch.getAll(this.baseUrl, options).models(Notification);
    }
    getAllDevice(id) {
        return this.fetch
            .getAll(this.baseUrl, { device_id: id })
            .req.pipe(map((res) => res.data));
    }
    delete(id) {
        return this.fetch.delete(this.baseUrl, id);
    }
    setRead(id, read) {
        return this.fetch.patch(this.baseUrl, id, { read });
    }
    getUnreadNotifications(id) {
        return this.getAll({ location_id: id, read: false })
            .pipe()
            .subscribe((res) => {
            this._unreadNotifications.next(res);
        });
    }
}
NotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i1.Fetch)); }, token: NotificationService, providedIn: "root" });
